function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M213.8 134.3c8.2 0 14.9 6.7 14.9 14.9s-6.7 14.9-14.9 14.9-14.9-6.7-14.9-14.9c0-8.3 6.7-14.9 14.9-14.9m0-16c-17 0-30.9 13.8-30.9 30.9 0 17 13.8 30.9 30.9 30.9 17 0 30.9-13.8 30.9-30.9-.1-17.1-13.9-30.9-30.9-30.9zm5.8-33.6V28.4H0v170h64.3V255h219.1V84.7h-63.8zM28.5 169.9v-113h162.6v27.8H64.3v85.1H28.5v.1zm84.7 56.6l43.1-43.1 43.1 43.1h-86.2zM255 186.6l-27.7 27.7-70.9-70.9-63.5 63.5v-93.7H255v73.4z"
})));